import EventHandler from '../../utils/dom/event-handler';
import SelectorEngine from '../../utils/dom/selector-engine';
import Request, { ApiMode } from '../../utils/request';
import Modal from '../../components/Modal';
import FormGenerator, { FormTypes } from '../../components/FormGenerator';
import { startLoadingAnimation, stopLoadingAnimation } from '../../utils/dom/loading';
import Manipulator from '../../utils/dom/manipulator';

const SELECTOR_WRAPPER = '.p-park-activator';
const SELECTOR_MODAL = '#js-park-activator-modal';

const SELECTOR_SPLASH = '.p-park-activator-splash';
const SELECTOR_SPLASH_NEXT = '.p-park-activator-splash-next';

const SELECTOR_SUCCESS = '.p-park-activator-success';
const SELECTOR_SUCCESS_BUTTON = '.p-park-activator-success--button';

const SELECTOR_STEP = '.p-park-activator-step';
const SELECTOR_QUESTION = '.p-park-activator-questions';
const SELECTOR_STEP_NEXT = '.p-park-activator-step-next';

const KEY_OBJECT = 'fieldName';
const VALUE_OBJECT = 'value';
const REFERENCE_VALUE_OBJECT = 'label';

const CLICK_EVENT = 'click';
const HIDDEN_CLASS = 'u-hidden';

const IS_LOCAL = false;

class ParkActivator {
	constructor() {
		this._wrapper = SelectorEngine.findOne(SELECTOR_WRAPPER);
		this.formElementsList = {};
		if (!this._wrapper) {
			return;
		}
		this.init();
	}

	get stepsData() {
		return this._stepsData;
	}

	set stepsData(_stepsData) {
		this._stepsData = _stepsData;
		if (_stepsData?.length > 0) {
			this.initiateFormGenerator(_stepsData);
		}
	}

	init() {
		this.parkActivatorModalElement = SelectorEngine.findOne(SELECTOR_MODAL, this._wrapper);

		this.parkActivatorSplash = SelectorEngine.findOne(SELECTOR_SPLASH, this._wrapper);
		this.parkActivatorSplashNext = SelectorEngine.findOne(SELECTOR_SPLASH_NEXT, this.parkActivatorSplash);

		this.parkActivatorStep = SelectorEngine.findOne(SELECTOR_STEP, this._wrapper);
		this.parkActivatorQuestion = SelectorEngine.findOne(SELECTOR_QUESTION, this.parkActivatorStep);
		this.parkActivatorStepNext = SelectorEngine.findOne(SELECTOR_STEP_NEXT, this.parkActivatorStep);

		this.parkActivatorSuccess = SelectorEngine.findOne(SELECTOR_SUCCESS, this._wrapper);
		this.parkActivatorSuccessButton = SelectorEngine.findOne(SELECTOR_SUCCESS_BUTTON, this.parkActivatorSuccess);

		this.isExistingUser = Manipulator.getDataAttribute(this._wrapper, 'show-reference-popup');

		this.parkActivatorModal = new Modal(this.parkActivatorModalElement, { backdrop: 'static' });
		this.parkActivatorModal.isEscapeEventEnable = false;

		this.parkActivatorModal.show();

		if(this.isExistingUser) {
			this.fetchParkActivatorSteps();
		}

		EventHandler.on(this.parkActivatorSplashNext, CLICK_EVENT, () => {
			this.fetchParkActivatorSteps();
		});
		EventHandler.on(this.parkActivatorSuccessButton, CLICK_EVENT, () => {
			this.parkActivatorModal.hide();
		});
	}
	showSuccessPage() {
		this.parkActivatorStep.classList.add(HIDDEN_CLASS);
		this.parkActivatorSuccess.classList.remove(HIDDEN_CLASS);
	}
	initiateFormGenerator(stepsData) {
		this.parkActivatorSplash.classList.add(HIDDEN_CLASS);
		this.parkActivatorStep.classList.remove(HIDDEN_CLASS);

		this.formGenerator = new FormGenerator(this.parkActivatorQuestion, {
			questions: stepsData,
			totalSteps: this.isExistingUser ? 1 : 4,
			stepTitle: 'YOUR VENUE',
			hasSeparator: false,
			formType: FormTypes.StepForm,
			themeColor: 'color-lta-blue',
			radioAnswerField: 'id',
			isBackButtonEnabled: !this.isExistingUser,
			backButtonHandlerFirstStep: () => {
				this.parkActivatorSplash.classList.remove(HIDDEN_CLASS);
				this.parkActivatorStep.classList.add(HIDDEN_CLASS);
			}
		});
		this.formGenerator.onChange((answers) => {
			this.prepareRequestObject(answers);
			this.saveParkActivatorSteps(this.answerList);
		});
	}
	prepareRequestObject(stepsAnswers) {
		this.answerList = {};
		for (const stepKey in stepsAnswers) {
			const stepAnswersObjects = stepsAnswers[stepKey];
			for (const questionKey in stepAnswersObjects) {
				const answerObject = stepAnswersObjects[questionKey];
				const formatObject = {};
				formatObject[answerObject[KEY_OBJECT]] = answerObject[VALUE_OBJECT];
				if(answerObject[KEY_OBJECT] === 'reference') {
					formatObject[answerObject[KEY_OBJECT]] = answerObject.isOthers ? answerObject.value : answerObject[REFERENCE_VALUE_OBJECT].trim();
				}
				this.answerList = {
					source: ['LTA Youth Tennis'],
					...this.answerList,
					...formatObject
				};
			}
		}
	}
	async fetchParkActivatorSteps() {
		try {
			const url = '/api/parksactivators/steps';
			const response = await Request.get(
				url,
				// { isExisting: true },
				{
					local: IS_LOCAL,
					req: {
						apiMode: ApiMode.LtaError
					}
				}
			);
			const { Steps, error } = response;
			if (Steps) {
				this.stepsData = Steps;
			}

			if (!!error?.hasError) {
				throw error;
			}
		} catch (error) {
			if (error.hasError) {
				console.log('Error : ', error);
			}
		}
	}
	async saveParkActivatorSteps(requestObject) {
		startLoadingAnimation();
		try {
			const url = '/api/parksactivators/SaveParksActivatorsOnboardingDetails';
			const response = await Request.post(url, requestObject, {
				local: IS_LOCAL,
				req: {
					apiMode: ApiMode.LtaError
				}
			});
			const { Success, success, error } = response;
			stopLoadingAnimation();
			if (Success || success) {
				this.showSuccessPage();
			}

			if (!!error?.hasError) {
				throw error;
			}
		} catch (error) {
			stopLoadingAnimation();
			if (error.hasError) {
				console.log('Error : ', error);
			}
		}
	}
}

const globalParkActivator = new ParkActivator();
export default globalParkActivator;
